package com.uludi.bard.theme.color

import androidx.compose.ui.graphics.Color

val primaryLight = Color(0xFF904A49)
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFFFFDAD8)
val onPrimaryContainerLight = Color(0xFF3B080B)
val secondaryLight = Color(0xFF924847)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFFFABA8)
val onSecondaryContainerLight = Color(0xFF5B1D1E)
val tertiaryLight = Color(0xFF795900)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFFDDA827)
val onTertiaryContainerLight = Color(0xFF322300)
val errorLight = Color(0xFFBA1A1A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val onErrorContainerLight = Color(0xFF410002)
val backgroundLight = Color(0xFFFFF8F7)
val onBackgroundLight = Color(0xFF251818)
val surfaceLight = Color(0xFFFFF8F7)
val onSurfaceLight = Color(0xFF251818)
val surfaceVariantLight = Color(0xFFFEDAD8)
val onSurfaceVariantLight = Color(0xFF594140)
val outlineLight = Color(0xFF8D706F)
val outlineVariantLight = Color(0xFFE1BFBD)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF3C2D2C)
val inverseOnSurfaceLight = Color(0xFFFFEDEB)
val inversePrimaryLight = Color(0xFFFFB3B0)
val surfaceDimLight = Color(0xFFEDD4D3)
val surfaceBrightLight = Color(0xFFFFF8F7)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFFFF0EF)
val surfaceContainerLight = Color(0xFFFFE9E7)
val surfaceContainerHighLight = Color(0xFFFCE2E1)
val surfaceContainerHighestLight = Color(0xFFF6DDDB)

val primaryLightMediumContrast = Color(0xFF904A49)
val onPrimaryLightMediumContrast = Color(0xFFFFFFFF)
val primaryContainerLightMediumContrast = Color(0xFFCF4247)
val onPrimaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val secondaryLightMediumContrast = Color(0xFF702E2E)
val onSecondaryLightMediumContrast = Color(0xFFFFFFFF)
val secondaryContainerLightMediumContrast = Color(0xFFAD5E5C)
val onSecondaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryLightMediumContrast = Color(0xFF573F00)
val onTertiaryLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightMediumContrast = Color(0xFF956E00)
val onTertiaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val errorLightMediumContrast = Color(0xFF8C0009)
val onErrorLightMediumContrast = Color(0xFFFFFFFF)
val errorContainerLightMediumContrast = Color(0xFFDA342E)
val onErrorContainerLightMediumContrast = Color(0xFFFFFFFF)
val backgroundLightMediumContrast = Color(0xFFFFF8F7)
val onBackgroundLightMediumContrast = Color(0xFF251818)
val surfaceLightMediumContrast = Color(0xFFFFF8F7)
val onSurfaceLightMediumContrast = Color(0xFF251818)
val surfaceVariantLightMediumContrast = Color(0xFFFEDAD8)
val onSurfaceVariantLightMediumContrast = Color(0xFF553D3C)
val outlineLightMediumContrast = Color(0xFF735957)
val outlineVariantLightMediumContrast = Color(0xFF917472)
val scrimLightMediumContrast = Color(0xFF000000)
val inverseSurfaceLightMediumContrast = Color(0xFF3C2D2C)
val inverseOnSurfaceLightMediumContrast = Color(0xFFFFEDEB)
val inversePrimaryLightMediumContrast = Color(0xFFFFB3B0)
val surfaceDimLightMediumContrast = Color(0xFFEDD4D3)
val surfaceBrightLightMediumContrast = Color(0xFFFFF8F7)
val surfaceContainerLowestLightMediumContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightMediumContrast = Color(0xFFFFF0EF)
val surfaceContainerLightMediumContrast = Color(0xFFFFE9E7)
val surfaceContainerHighLightMediumContrast = Color(0xFFFCE2E1)
val surfaceContainerHighestLightMediumContrast = Color(0xFFF6DDDB)

val primaryLightHighContrast = Color(0xFF904A49)
val onPrimaryLightHighContrast = Color(0xFFFFFFFF)
val primaryContainerLightHighContrast = Color(0xFF89091B)
val onPrimaryContainerLightHighContrast = Color(0xFFFFFFFF)
val secondaryLightHighContrast = Color(0xFF450D10)
val onSecondaryLightHighContrast = Color(0xFFFFFFFF)
val secondaryContainerLightHighContrast = Color(0xFF702E2E)
val onSecondaryContainerLightHighContrast = Color(0xFFFFFFFF)
val tertiaryLightHighContrast = Color(0xFF2E2000)
val onTertiaryLightHighContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightHighContrast = Color(0xFF573F00)
val onTertiaryContainerLightHighContrast = Color(0xFFFFFFFF)
val errorLightHighContrast = Color(0xFF4E0002)
val onErrorLightHighContrast = Color(0xFFFFFFFF)
val errorContainerLightHighContrast = Color(0xFF8C0009)
val onErrorContainerLightHighContrast = Color(0xFFFFFFFF)
val backgroundLightHighContrast = Color(0xFFFFF8F7)
val onBackgroundLightHighContrast = Color(0xFF251818)
val surfaceLightHighContrast = Color(0xFFFFF8F7)
val onSurfaceLightHighContrast = Color(0xFF000000)
val surfaceVariantLightHighContrast = Color(0xFFFEDAD8)
val onSurfaceVariantLightHighContrast = Color(0xFF331F1E)
val outlineLightHighContrast = Color(0xFF553D3C)
val outlineVariantLightHighContrast = Color(0xFF553D3C)
val scrimLightHighContrast = Color(0xFF000000)
val inverseSurfaceLightHighContrast = Color(0xFF3C2D2C)
val inverseOnSurfaceLightHighContrast = Color(0xFFFFFFFF)
val inversePrimaryLightHighContrast = Color(0xFFFFE7E5)
val surfaceDimLightHighContrast = Color(0xFFEDD4D3)
val surfaceBrightLightHighContrast = Color(0xFFFFF8F7)
val surfaceContainerLowestLightHighContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightHighContrast = Color(0xFFFFF0EF)
val surfaceContainerLightHighContrast = Color(0xFFFFE9E7)
val surfaceContainerHighLightHighContrast = Color(0xFFFCE2E1)
val surfaceContainerHighestLightHighContrast = Color(0xFFF6DDDB)

val primaryDark = Color(0xFFFFB3B0)
val onPrimaryDark = Color(0xFF680010)
val primaryContainerDark = Color(0xFFF65E61)
val onPrimaryContainerDark = Color(0xFF000000)
val secondaryDark = Color(0xFFFFB3B0)
val onSecondaryDark = Color(0xFF581C1D)
val secondaryContainerDark = Color(0xFF6A2929)
val onSecondaryContainerDark = Color(0xFFFFC3C0)
val tertiaryDark = Color(0xFFF7BF3F)
val onTertiaryDark = Color(0xFF402D00)
val tertiaryContainerDark = Color(0xFFC99711)
val onTertiaryContainerDark = Color(0xFF1A1100)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF1D1010)
val onBackgroundDark = Color(0xFFF6DDDB)
val surfaceDark = Color(0xFF1D1010)
val onSurfaceDark = Color(0xFFF6DDDB)
val surfaceVariantDark = Color(0xFF594140)
val onSurfaceVariantDark = Color(0xFFE1BFBD)
val outlineDark = Color(0xFFA88A88)
val outlineVariantDark = Color(0xFF594140)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFF6DDDB)
val inverseOnSurfaceDark = Color(0xFF3C2D2C)
val inversePrimaryDark = Color(0xFFB02B33)
val surfaceDimDark = Color(0xFF1D1010)
val surfaceBrightDark = Color(0xFF453535)
val surfaceContainerLowestDark = Color(0xFF170B0B)
val surfaceContainerLowDark = Color(0xFF251818)
val surfaceContainerDark = Color(0xFF2A1C1C)
val surfaceContainerHighDark = Color(0xFF352626)
val surfaceContainerHighestDark = Color(0xFF413130)

val primaryDarkMediumContrast = Color(0xFFFFB3B0)
val onPrimaryDarkMediumContrast = Color(0xFF370005)
val primaryContainerDarkMediumContrast = Color(0xFFF65E61)
val onPrimaryContainerDarkMediumContrast = Color(0xFF000000)
val secondaryDarkMediumContrast = Color(0xFFFFB9B6)
val onSecondaryDarkMediumContrast = Color(0xFF350206)
val secondaryContainerDarkMediumContrast = Color(0xFFCF7977)
val onSecondaryContainerDarkMediumContrast = Color(0xFF000000)
val tertiaryDarkMediumContrast = Color(0xFFFAC241)
val onTertiaryDarkMediumContrast = Color(0xFF1F1500)
val tertiaryContainerDarkMediumContrast = Color(0xFFC99711)
val onTertiaryContainerDarkMediumContrast = Color(0xFF000000)
val errorDarkMediumContrast = Color(0xFFFFBAB1)
val onErrorDarkMediumContrast = Color(0xFF370001)
val errorContainerDarkMediumContrast = Color(0xFFFF5449)
val onErrorContainerDarkMediumContrast = Color(0xFF000000)
val backgroundDarkMediumContrast = Color(0xFF1D1010)
val onBackgroundDarkMediumContrast = Color(0xFFF6DDDB)
val surfaceDarkMediumContrast = Color(0xFF1D1010)
val onSurfaceDarkMediumContrast = Color(0xFFFFF9F9)
val surfaceVariantDarkMediumContrast = Color(0xFF594140)
val onSurfaceVariantDarkMediumContrast = Color(0xFFE5C3C1)
val outlineDarkMediumContrast = Color(0xFFBB9B9A)
val outlineVariantDarkMediumContrast = Color(0xFF997C7B)
val scrimDarkMediumContrast = Color(0xFF000000)
val inverseSurfaceDarkMediumContrast = Color(0xFFF6DDDB)
val inverseOnSurfaceDarkMediumContrast = Color(0xFF352626)
val inversePrimaryDarkMediumContrast = Color(0xFF90111F)
val surfaceDimDarkMediumContrast = Color(0xFF1D1010)
val surfaceBrightDarkMediumContrast = Color(0xFF453535)
val surfaceContainerLowestDarkMediumContrast = Color(0xFF170B0B)
val surfaceContainerLowDarkMediumContrast = Color(0xFF251818)
val surfaceContainerDarkMediumContrast = Color(0xFF2A1C1C)
val surfaceContainerHighDarkMediumContrast = Color(0xFF352626)
val surfaceContainerHighestDarkMediumContrast = Color(0xFF413130)

val primaryDarkHighContrast = Color(0xFFFCB0D6)
val onPrimaryDarkHighContrast = Color(0xFF000000)
val primaryContainerDarkHighContrast = Color(0xFFFFB9B6)
val onPrimaryContainerDarkHighContrast = Color(0xFF000000)
val secondaryDarkHighContrast = Color(0xFFFFF9F9)
val onSecondaryDarkHighContrast = Color(0xFF000000)
val secondaryContainerDarkHighContrast = Color(0xFFFFB9B6)
val onSecondaryContainerDarkHighContrast = Color(0xFF000000)
val tertiaryDarkHighContrast = Color(0xFFFFFAF7)
val onTertiaryDarkHighContrast = Color(0xFF000000)
val tertiaryContainerDarkHighContrast = Color(0xFFFAC241)
val onTertiaryContainerDarkHighContrast = Color(0xFF000000)
val errorDarkHighContrast = Color(0xFFFFF9F9)
val onErrorDarkHighContrast = Color(0xFF000000)
val errorContainerDarkHighContrast = Color(0xFFFFBAB1)
val onErrorContainerDarkHighContrast = Color(0xFF000000)
val backgroundDarkHighContrast = Color(0xFF1D1010)
val onBackgroundDarkHighContrast = Color(0xFFF6DDDB)
val surfaceDarkHighContrast = Color(0xFF1D1010)
val onSurfaceDarkHighContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkHighContrast = Color(0xFF594140)
val onSurfaceVariantDarkHighContrast = Color(0xFFFFF9F9)
val outlineDarkHighContrast = Color(0xFFE5C3C1)
val outlineVariantDarkHighContrast = Color(0xFFE5C3C1)
val scrimDarkHighContrast = Color(0xFF000000)
val inverseSurfaceDarkHighContrast = Color(0xFFF6DDDB)
val inverseOnSurfaceDarkHighContrast = Color(0xFF000000)
val inversePrimaryDarkHighContrast = Color(0xFF5C000D)
val surfaceDimDarkHighContrast = Color(0xFF1D1010)
val surfaceBrightDarkHighContrast = Color(0xFF453535)
val surfaceContainerLowestDarkHighContrast = Color(0xFF170B0B)
val surfaceContainerLowDarkHighContrast = Color(0xFF251818)
val surfaceContainerDarkHighContrast = Color(0xFF2A1C1C)
val surfaceContainerHighDarkHighContrast = Color(0xFF352626)
val surfaceContainerHighestDarkHighContrast = Color(0xFF413130)







